(function () {
  var modal = document.getElementById('hr-sizefinder');
  if (!modal || modal.dataset.bound) return;
  modal.dataset.bound = '1';
  var panel = modal.querySelector('.sf__panel');

  var SHOW_SCAN = window.HR_SF_CFG.scan;
  var SHOW_SAVE = window.HR_SF_CFG.save;
  var PRODUCT_TITLE = window.HR_SF_CFG.title;
  var PRODUCT_IMG = window.HR_SF_CFG.image;
  var SCAN_URL = window.HR_SF_CFG.scanUrl;

  // ---- Data ----
  var GENDERS = ['Masculino', 'Femenino', 'Prefiero no decirlo'];
  var GENDER_SEL = ['Hombres', 'Mujeres', 'Unisex'];
  var UNITS = ['Colombia', 'EU', 'US', 'UK'];
  var WIDTHS = ['Extra estrecho', 'Angosto', 'Estándar', 'Ancho', 'Extra ancho'];
  var SIZES = [];
  for (var s = 33; s <= 45; s += 1) SIZES.push(s);
  var WIDTH_FACTOR = { 'Extra estrecho': 0.355, 'Angosto': 0.368, 'Estándar': 0.378, 'Ancho': 0.392, 'Extra ancho': 0.405 };
  var FIT_POS = { 'Extra estrecho': 14, 'Angosto': 32, 'Estándar': 50, 'Ancho': 68, 'Extra ancho': 86 };
  /* Tabla oficial Rómulo (talla → longitud del pie en cm), por género */
  /* MISMA tabla que la guía de tallas del sitio (hr-beta-sizeguide,
     hr-size-guide y /pages/medir-talla) — mantener las 4 fuentes iguales. */
  var ROMULO = {
    /* 3-nov-2026: dama sale de medir la plantilla real (moldes Soft 2 y Samanta): mitad del rango de pie de la guía */
    mujer:  {33:21.4,34:22.1,35:22.8,36:23.5,37:24.2,38:24.8,39:25.4,40:26.0,41:26.7},
    hombre: {36:24.0,37:24.5,38:25.0,39:25.5,40:26.0,41:26.5,42:27.0,43:27.5,44:28.5,45:29.0}
  };
  /* 26-oct-2026: si el producto trae la tabla de su proveedor (metacampo custom.tabla_tallas), se usa esa */
  var TABLA_PROV = null;
  try {
    var tt = window.HR_SF_CFG.tabla;
    if (tt && tt.tallas && tt.tallas.length) {
      /* tabla de plantilla: el pie mide ~0,75 cm menos (los fabricantes piden 0,5–1 cm de holgura) */
      var ajuste = tt.medida === 'plantilla' ? 0.75 : 0;
      TABLA_PROV = {}; tt.tallas.forEach(function (f) { TABLA_PROV[Number(f.t)] = Math.round((Number(f.cm) - ajuste) * 10) / 10; });
    }
  } catch (e) { TABLA_PROV = null; }
  var lenForSize = function (size) {
    var tab = TABLA_PROV || ((st && st.genderSel === 'Hombres') ? ROMULO.hombre : ROMULO.mujer);
    var keys = Object.keys(tab).map(Number).sort(function (a, b) { return a - b; });
    var sz = Math.round(size);
    if (tab[sz] != null) return tab[sz];
    if (sz < keys[0]) return tab[keys[0]];
    return tab[keys[keys.length - 1]];
  };

  // ---- Icons ----
  var IC = {
    chevL: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 6-6 6 6 6"/></svg>',
    chevR: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>',
    chevD: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>',
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    menu: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>',
    check: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    checkBig: '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    arrowR: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>',
    refresh: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 4v6h-6"/><path d="M3 20v-6h6"/><path d="M3.5 9a9 9 0 0 1 15-3.5L21 8"/><path d="M20.5 15a9 9 0 0 1-15 3.5L3 16"/></svg>',
    run: '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="40" cy="11" r="5.5" fill="currentColor" stroke="none"/><path d="M44 22c-4-2-9-1-12 2l-7 7 8 6-3 13"/><path d="M33 31l10 4 6 9"/><path d="M25 31l-9 2-5 9"/><path d="M29 44l-9 3-6 10"/></svg>',
    sliders: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h10M18 6h2M4 12h2M10 12h10M4 18h7M15 18h5"/><circle cx="16" cy="6" r="2"/><circle cx="8" cy="12" r="2"/><circle cx="13" cy="18" r="2"/></svg>',
    feet: '<svg class="sf-feet" viewBox="0 0 220 150" fill="none" stroke="var(--hr-graphite)" stroke-width="1.6"><path d="M58 16c10 0 16 11 16 26 0 11-3 19-3 30 0 9 3 14 3 24 0 12-7 20-16 20s-15-7-15-18c0-9 3-13 3-23 0-12-4-20-4-32 0-16 6-27 16-27Z"/><path d="M162 16c-10 0-16 11-16 26 0 11 3 19 3 30 0 9-3 14-3 24 0 12 7 20 16 20s15-7 15-18c0-9-3-13-3-23 0-12 4-20 4-32 0-16-6-27-16-27Z"/></svg>'
  };

  // ---- Faux QR (deterministic) ----
  function qrSVG() {
    var n = 25;
    var m = [];
    var r, c, i, j;
    for (r = 0; r < n; r++) { m[r] = []; for (c = 0; c < n; c++) m[r][c] = false; }
    function finder(fr, fc) {
      for (i = -1; i <= 7; i++) for (j = -1; j <= 7; j++) {
        var rr = fr + i, cc = fc + j;
        if (rr < 0 || cc < 0 || rr >= n || cc >= n) continue;
        var edge = i === 0 || i === 6 || j === 0 || j === 6;
        var core = i >= 2 && i <= 4 && j >= 2 && j <= 4;
        m[rr][cc] = edge || core;
      }
    }
    finder(0, 0); finder(0, n - 7); finder(n - 7, 0);
    var seed = 9301;
    var rnd = function () { seed = (seed * 233280 + 49297) % 233280; return seed / 233280; };
    for (r = 0; r < n; r++) for (c = 0; c < n; c++) {
      var inF = (r < 8 && c < 8) || (r < 8 && c >= n - 8) || (r >= n - 8 && c < 8);
      if (!inF && rnd() > 0.55) m[r][c] = true;
    }
    var rects = '';
    for (r = 0; r < n; r++) for (c = 0; c < n; c++) {
      if (m[r][c]) rects += '<rect x="' + c + '" y="' + r + '" width="1" height="1" fill="var(--hr-ink)"/>';
    }
    return '<svg viewBox="0 0 25 25" shape-rendering="crispEdges" width="100%" height="100%">' + rects + '</svg>';
  }

  // ---- State ----
  var st;
  function reset() {
    st = {
      screen: 'intro', step: 0, gender: null, genderSel: 'Mujeres', unit: 'Colombia',
      size: null, width: null, resSize: 38, baseSize: null, measUnit: 'cm', moreOpen: false,
      termsOk: false, offersOk: false, saved: false, showSave: true
    };
  }
  reset();

  // ---- Helpers ----
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function fmtSize(s) { return String(s); }
  function emailValid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || ''); }

  function headerHTML(showBack) {
    return '<div class="sf-top">' +
      (showBack
        ? '<button type="button" class="sf-pill" data-act="back">' + IC.chevL + ' Atrás</button>'
        : '<span></span>') +
      '<button class="sf-close" data-act="close" aria-label="Cerrar">' + IC.close + '</button>' +
      '</div>';
  }

  function dotsHTML(n, i) {
    var out = '';
    for (var k = 0; k < n; k++) out += '<span class="' + (k === i ? 'is-on' : '') + '"></span>';
    return '<div class="sf-dots">' + out + '</div>';
  }

  // ---- Screens ----
  function introHTML() {
    return headerHTML(false) +
      '<div class="sf-body sf-intro">' +
        '<div class="sf-run">' + IC.run + '</div>' +
        '<h2 class="sf-h1">Encuentre su talla</h2>' +
        '<p class="sf-lede">En un minuto le recomendamos la talla y el ancho ideal para su pie.</p>' +
        (SHOW_SCAN ? '<button class="sf-opt sf-opt--gold" data-act="goqr"><div><div class="sf-opt__h">Escanear el pie' + (SCAN_URL ? '' : ' <span style="display:inline-block;margin-left:6px;font-size:9px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:#fff;background:#128C7E;padding:2px 7px;border-radius:999px;vertical-align:middle">Próximamente</span>') + '</div><div class="sf-opt__d">Obtenga la medida más precisa con un simple escaneo del pie.</div></div>' + IC.arrowR + '</button>' : '') +
        '<button class="sf-opt sf-opt--line" data-act="gomanual"><div><div class="sf-opt__h">Responder unas preguntas</div><div class="sf-opt__d">Responda tres preguntas rápidas sobre su talla habitual.</div></div>' + IC.arrowR + '</button>' +
      '</div>';
  }

  function isMobile() { return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || ''); }
  function scanURL() {
    if (!SCAN_URL) return '';
    var base = SCAN_URL;
    if (base.charAt(0) === '/') base = location.origin + base;   // relativo → absoluto (QR sirve en cualquier dominio)
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'genero=' + encodeURIComponent(st.genderSel || '') + '&producto=' + encodeURIComponent(PRODUCT_TITLE || '');
  }
  function qrHTML() {
    // Sin URL configurada → "Próximamente"
    if (!SCAN_URL) {
      return headerHTML(true) +
        '<div class="sf-body sf-intro" style="text-align:center">' +
          '<div class="sf-run">' + IC.run + '</div>' +
          '<h2 class="sf-h1">Escaneo del pie · Próximamente</h2>' +
          '<p class="sf-lede">Estamos desarrollando el escaneo del pie desde tu celular para darte la medida más precisa. ¡Muy pronto disponible!</p>' +
          '<button class="sf-opt sf-opt--line" data-act="gomanual"><div><div class="sf-opt__h">Mientras tanto, responder unas preguntas</div><div class="sf-opt__d">Responda tres preguntas rápidas sobre su talla habitual.</div></div>' + IC.arrowR + '</button>' +
        '</div>';
    }
    var url = scanURL();
    // En el celular → abrir el escáner directo
    if (isMobile()) {
      return headerHTML(true) +
        '<div class="sf-body sf-intro" style="text-align:center">' +
          '<div class="sf-run">' + IC.run + '</div>' +
          '<h2 class="sf-h1">Escanee su pie</h2>' +
          '<p class="sf-lede">Abra el escáner, use una tarjeta como referencia de tamaño y siga los pasos. En un minuto tendrá su talla.</p>' +
          '<a class="sf-btn" href="' + esc(url) + '" target="_blank" rel="noopener">Abrir el escáner</a>' +
        '</div>';
    }
    // En escritorio → QR real para pasar al celular
    return headerHTML(true) +
      '<div class="sf-body sf-qrscreen" style="text-align:center">' +
        '<h2 class="sf-h2">Escanee el código con su celular</h2>' +
        '<p class="sf-lede">Apunte la cámara de su teléfono al código para abrir el escáner de pie.</p>' +
        '<div class="sf-qr"><img src="https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=10&data=' + encodeURIComponent(url) + '" alt="Código QR" width="240" height="240" style="width:100%;height:auto;display:block"></div>' +
        '<a class="sf-link" href="' + esc(url) + '" target="_blank" rel="noopener" style="display:inline-block;margin-top:12px;word-break:break-all;font-size:13px">Abrir en este equipo</a>' +
      '</div>';
  }

  function genderStep() {
    return '<h2 class="sf-h2">Seleccione su género</h2>' +
      '<span class="sf-flabel">Género <span class="sf-req">*</span></span>' +
      '<div class="sf-radios">' +
        GENDERS.map(function (g) { return '<button class="sf-radio' + (st.gender === g ? ' is-on' : '') + '" data-gender="' + esc(g) + '"><span class="sf-radio__dot"></span>' + g + '</button>'; }).join('') +
      '</div>';
  }

  function sizeStep() {
    return '<h2 class="sf-h2">Seleccione su talla habitual</h2>' +
      '<div class="sf-selrow">' +
        '<label class="sf-select"><span>Género</span><select data-gendersel>' +
          GENDER_SEL.map(function (g) { return '<option' + (st.genderSel === g ? ' selected' : '') + '>' + g + '</option>'; }).join('') +
        '</select>' + IC.chevD + '</label>' +
        '<label class="sf-select sf-select--active"><span>Unidad de talla</span><select data-unit>' +
          UNITS.map(function (u) { return '<option' + (st.unit === u ? ' selected' : '') + '>' + u + '</option>'; }).join('') +
        '</select>' + IC.chevD + '</label>' +
      '</div>' +
      '<span class="sf-flabel">Talla</span>' +
      '<div class="sf-sizegrid">' +
        SIZES.map(function (sz) { return '<button class="sf-size' + (st.size === sz ? ' is-on' : '') + '" data-size="' + sz + '">' + fmtSize(sz) + '</button>'; }).join('') +
      '</div>';
  }

  function widthStep() {
    return '<h2 class="sf-h2">¿Qué ancho tienen sus pies?</h2>' +
      IC.feet +
      '<span class="sf-flabel">Ancho del pie <span class="sf-req">*</span></span>' +
      '<div class="sf-radios">' +
        WIDTHS.map(function (w) { return '<button class="sf-radio' + (st.width === w ? ' is-on' : '') + '" data-width="' + esc(w) + '"><span class="sf-radio__dot"></span>' + w + '</button>'; }).join('') +
      '</div>';
  }

  function manualHTML() {
    var body = st.step === 0 ? genderStep() : (st.step === 1 ? sizeStep() : widthStep());
    var canNext = (st.step === 0 && st.gender) || (st.step === 1 && st.size) || (st.step === 2 && st.width);
    return headerHTML(true) +
      '<div class="sf-body sf-manual">' + body + '</div>' +
      '<div class="sf-foot">' +
        '<button class="sf-foot__btn" data-act="back">Atrás</button>' +
        dotsHTML(3, st.step) +
        '<button class="sf-foot__btn sf-foot__next' + (canNext ? ' is-on' : '') + '" data-act="next"' + (canNext ? '' : ' disabled') + '>' + (st.step === 2 ? 'Finalizar' : 'Siguiente') + '</button>' +
      '</div>';
  }

  function saveHTML() {
    if (!SHOW_SAVE) return '';
    if (st.saved) return '<div class="sf-saved">' + IC.check + ' Perfil guardado. Le escribiremos con su talla.</div>';
    if (!st.showSave) return '';
    return '<div class="sf-save">' +
      '<div class="sf-save__h">No pierda su perfil</div>' +
      '<input class="sf-input" type="email" placeholder="Correo electrónico" data-email>' +
      '<button class="sf-chk" data-act="terms"><span class="sf-chk__box">' + IC.check + '</span>Acepto los términos y la política de privacidad.</button>' +
      '<button class="sf-chk" data-act="offers"><span class="sf-chk__box">' + IC.check + '</span>Deseo recibir recomendaciones y novedades de Horma Real.</button>' +
      '<div class="sf-save__cta">' +
        '<button class="sf-btn sf-btn--disabled" data-act="save" disabled>Guardar perfil de ajuste ' + IC.arrowR + '</button>' +
        '<button class="sf-skip" data-act="skip">Omitir</button>' +
      '</div>' +
    '</div>';
  }

  function resultHTML() {
    var shoe = PRODUCT_IMG ? '<img src="' + esc(PRODUCT_IMG) + '" alt="' + esc(PRODUCT_TITLE) + '">' : '<div class="sf-reco__placeholder"></div>';
    return headerHTML(false) +
      '<div class="sf-body sf-result">' +
        '<div class="sf-check">' + IC.checkBig + '</div>' +
        '<h2 class="sf-h2 sf-h2--c">Su talla recomendada</h2>' +
        '<div class="sf-card sf-reco">' +
          '<div class="sf-reco__num"><span class="sf-reco__u">' + st.unit + '</span><span class="sf-reco__n" data-reco-n></span></div>' +
          '<div class="sf-reco__shoe">' + shoe + '</div>' +
        '</div>' +
        '<div class="sf-adj">' +
          '<div class="sf-adj__head">' + IC.sliders + ' Ajuste regulable</div>' +
          '<div class="sf-card sf-meas">' +
            '<div class="sf-insole"><div class="sf-insole__shape"><div class="sf-insole__fill"></div></div>' +
              '<div class="sf-meas__len"><span>Longitud</span><strong data-meas-len></strong></div></div>' +
            '<div class="sf-meas__wid"><span>Ancho</span><strong data-meas-wid></strong></div>' +
            '<div class="sf-fit"><div class="sf-fit__bar"><span class="sf-fit__marker" data-fit-marker></span></div>' +
              '<div class="sf-fit__labels"><span>Ajustado</span><span>Equilibrado</span><span>Espacioso</span></div></div>' +
            '<div class="sf-stepper">' +
              '<button data-act="size-dec" aria-label="Bajar talla">' + IC.chevL + '</button>' +
              '<span data-reco-size></span>' +
              '<button data-act="size-inc" aria-label="Subir talla">' + IC.chevR + '</button>' +
              '<button class="sf-unit" data-act="unit-toggle">' + IC.refresh + ' <span data-unit-lbl></span></button>' +
            '</div>' +
            '<button class="sf-more" data-act="more">Más información <span class="sf-more__chev' + (st.moreOpen ? ' is-open' : '') + '" data-more-chev>' + IC.chevD + '</span></button>' +
            '<p class="sf-more__body" data-more-body' + (st.moreOpen ? '' : ' hidden') + '></p>' +
          '</div>' +
        '</div>' +
        saveHTML() +
      '</div>' +
      '<div class="sf-foot sf-foot--result"><button class="sf-btn sf-btn--dark" data-act="restart">Empezar de nuevo</button></div>';
  }

  // ---- Render ----
  function render() {
    if (st.screen === 'intro') panel.innerHTML = introHTML();
    else if (st.screen === 'qr') panel.innerHTML = qrHTML();
    else if (st.screen === 'manual') panel.innerHTML = manualHTML();
    else panel.innerHTML = resultHTML();
    if (st.screen === 'result') updateResult();
  }

  function updateResult() {
    var len = lenForSize(st.resSize);
    var wid = +(len * (WIDTH_FACTOR[st.width] || 0.378)).toFixed(2);
    var conv = function (cm) { return st.measUnit === 'cm' ? cm.toFixed(2) : (cm * 0.3937).toFixed(2); };
    var u = st.measUnit === 'cm' ? 'cm' : 'in';
    var set = function (sel, txt) { var el = panel.querySelector(sel); if (el) el.textContent = txt; };
    set('[data-reco-n]', fmtSize(st.resSize));
    set('[data-reco-size]', fmtSize(st.resSize) + ' ' + st.unit);
    set('[data-meas-len]', conv(len) + ' ' + u);
    set('[data-meas-wid]', conv(wid) + ' ' + u);
    set('[data-unit-lbl]', st.measUnit === 'cm' ? 'cm/pulg.' : 'pulg./cm');
    /* Ajuste visual: la preferencia de ancho da la base, y cada talla arriba/abajo
       de la recomendada mueve el ajuste hacia Espacioso/Ajustado. */
    var baseIdx = SIZES.indexOf(st.baseSize != null ? st.baseSize : st.resSize);
    var curIdx = SIZES.indexOf(st.resSize);
    var delta = (baseIdx > -1 && curIdx > -1) ? (curIdx - baseIdx) : 0;
    var score = Math.max(6, Math.min(94, (FIT_POS[st.width] || 50) + delta * 22));
    var marker = panel.querySelector('[data-fit-marker]');
    if (marker) marker.style.left = score + '%';
    var fill = panel.querySelector('.sf-insole__fill');
    if (fill) {
      fill.classList.remove('is-tight', 'is-roomy');
      if (score < 38) fill.classList.add('is-tight');
      else if (score > 62) fill.classList.add('is-roomy');
      /* pie más grande respecto al zapato = llena más la plantilla; más holgado = más margen */
      fill.style.transform = 'scale(' + (1.06 - score * 0.0016).toFixed(3) + ')';
    }
    var body = panel.querySelector('[data-more-body]');
    if (body) body.textContent = 'Su pie mide ' + conv(len) + ' ' + u + ' de largo y ' + conv(wid) + ' ' + u +
      ' de ancho. Para ' + PRODUCT_TITLE + ', la talla ' + fmtSize(st.resSize) + ' ' + st.unit +
      ' ofrece el mejor equilibrio entre ajuste y comodidad.';
  }

  // ---- Open / close ----
  var INLINE = modal.classList.contains('sf--inline');
  function open() { reset(); modal.hidden = false; if (!INLINE) document.body.classList.add('hr-sf-lock'); render(); panel.focus(); }
  function close() { if (INLINE) { reset(); render(); return; } modal.hidden = true; document.body.classList.remove('hr-sf-lock'); }

  function goNext() {
    if (st.step < 2) { st.step += 1; render(); }
    else { st.resSize = st.size || 38; st.baseSize = st.resSize; st.screen = 'result'; st.showSave = true; render(); }
  }
  function goBack() {
    if (st.screen === 'manual' && st.step > 0) { st.step -= 1; render(); }
    else if (st.screen === 'qr' || st.screen === 'manual') { st.screen = 'intro'; st.step = 0; render(); }
  }

  // ---- Events (delegated, survive innerHTML swaps) ----
  panel.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act], [data-gender], [data-size], [data-width]');
    if (!t) return;
    e.preventDefault();   // evita que estos botones envíen el <form> del producto que los envuelve

    if (t.dataset.gender !== undefined) { st.gender = t.dataset.gender; render(); return; }
    if (t.dataset.size !== undefined) { st.size = parseFloat(t.dataset.size); render(); return; }
    if (t.dataset.width !== undefined) { st.width = t.dataset.width; render(); return; }

    var act = t.dataset.act;
    switch (act) {
      case 'close': close(); break;
      case 'back': goBack(); break;
      case 'next': goNext(); break;
      case 'goqr': st.screen = 'qr'; render(); break;
      case 'gomanual': st.screen = 'manual'; st.step = 0; render(); break;
      case 'restart': reset(); render(); break;
      case 'size-dec': { var i = SIZES.indexOf(st.resSize); if (i > 0) { st.resSize = SIZES[i - 1]; updateResult(); } break; }
      case 'size-inc': { var j = SIZES.indexOf(st.resSize); if (j >= 0 && j < SIZES.length - 1) { st.resSize = SIZES[j + 1]; updateResult(); } break; }
      case 'unit-toggle': st.measUnit = st.measUnit === 'cm' ? 'in' : 'cm'; updateResult(); break;
      case 'more': {
        st.moreOpen = !st.moreOpen;
        var chev = panel.querySelector('[data-more-chev]');
        var body = panel.querySelector('[data-more-body]');
        if (chev) chev.classList.toggle('is-open', st.moreOpen);
        if (body) body.hidden = !st.moreOpen;
        break;
      }
      case 'terms': st.termsOk = !st.termsOk; t.classList.toggle('is-on', st.termsOk); syncSave(); break;
      case 'offers': st.offersOk = !st.offersOk; t.classList.toggle('is-on', st.offersOk); break;
      case 'save': {
        var em = panel.querySelector('[data-email]');
        if (emailValid(em && em.value) && st.termsOk) {
          /* captura real: registra el correo en Shopify (suscriptor de email) con etiqueta */
          var body = 'form_type=customer&utf8=%E2%9C%93&contact[email]=' + encodeURIComponent(em.value) +
                     '&contact[tags]=medidor-talla';
          try { fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body }); } catch (err) {}
          st.saved = true; render();
        }
        break;
      }
      case 'skip': st.showSave = false; render(); break;
    }
  });

  panel.addEventListener('input', function (e) {
    if (e.target.matches('[data-email]')) syncSave();
  });
  panel.addEventListener('change', function (e) {
    if (e.target.matches('[data-gendersel]')) st.genderSel = e.target.value;
    else if (e.target.matches('[data-unit]')) st.unit = e.target.value;
  });

  function syncSave() {
    var em = panel.querySelector('[data-email]');
    var btn = panel.querySelector('[data-act="save"]');
    if (!btn) return;
    var ok = emailValid(em && em.value) && st.termsOk;
    btn.disabled = !ok;
    btn.classList.toggle('sf-btn--disabled', !ok);
  }

  // scrim + esc
  modal.querySelector('[data-sf-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !INLINE && !modal.hidden) close(); });

  // triggers
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-open-sizefinder]');
    if (trig) { e.preventDefault(); open(); }
  });
  window.addEventListener('hr:open-sizefinder', open);

  // inline: render immediately and stay visible
  if (INLINE) { reset(); render(); }
})();
